import {
  Button,
  Loader,
  Modal,
  ModalContent,
  ModalTitle,
} from '@energybox/react-ui-library/dist/components';
import React, { ReactElement } from 'react';

export type GenericConfirmationModalProps = {
  title: string;
  description?: string | ReactElement;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  error?: string | ReactElement;
  disableEscapeClose?: boolean;
};

export default function GenericConfirmationModal({
  title,
  description,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isLoading = false,
  error,
  disableEscapeClose = false,
}: GenericConfirmationModalProps) {
  const actions = (
    <>
      <Button variant='text' onClick={onCancel} disabled={isLoading}>
        {cancelText}
      </Button>
      <Button onClick={onConfirm} disabled={isLoading} variant='solid'>
        {isLoading ? <Loader size={16} variant='secondary' /> : confirmText}
      </Button>
    </>
  );

  return (
    <Modal
      onClose={isLoading ? undefined : onCancel}
      actions={actions}
      disableEscapeClose={disableEscapeClose}
    >
      <ModalTitle>{title}</ModalTitle>
      {description && <ModalContent>{description}</ModalContent>}
      {error && (
        <div style={{ color: '#d32f2f', marginTop: '8px', fontSize: '14px' }}>
          {error}
        </div>
      )}
    </Modal>
  );
}
